// Cross-app handoff to my.tabletalk.app. Sign Up / Get Started buttons
// land on the app root with `signup=1` so the SPA opens its signup modal
// preloaded with the same locale, plan, currency, and country the user
// just saw on the marketing site. Login buttons land on the bare app root.

import { currencyForLocale } from "./pricing.js";

const SIGNUP_BASE =
  import.meta.env.VITE_SIGNUP_URL || "https://my.tabletalk.app/";

const LOGIN_URL =
  import.meta.env.VITE_LOGIN_URL || "https://my.tabletalk.app/";

// Calendly link used in place of all signup / claim-free-week / book-a-demo
// CTAs for now. Once the in-product signup flow is ready, repoint goToSignup
// back to buildSignupUrl and update the Book-a-demo callsites.
const BOOKING_URL =
  import.meta.env.VITE_BOOKING_URL || "https://calendly.com/matei-delipal/tabletalk";

export function buildSignupUrl({ locale = "en", planId, country } = {}) {
  const url = new URL(SIGNUP_BASE);
  url.searchParams.set("signup", "1");
  url.searchParams.set("lang", locale);
  url.searchParams.set("currency", currencyForLocale(locale));
  if (planId) url.searchParams.set("plan", planId);
  if (country) url.searchParams.set("country", country);
  url.searchParams.set("from", "marketing");
  return url.toString();
}

// Both destinations live outside the marketing site, so they open alongside it
// rather than replacing it.
function openExternal(url) {
  window.open(url, "_blank", "noopener,noreferrer");
}

export function goToBooking() {
  openExternal(BOOKING_URL);
}

// Temporarily routed to the booking link — every "Start for free" and
// "Claim your free week" CTA goes through here. See BOOKING_URL note above.
export function goToSignup(_opts = {}) {
  goToBooking();
}

export function goToLogin() {
  openExternal(LOGIN_URL);
}
